<script>
  import {VueMaskDirective as mask} from 'v-mask'
  import service from '../../../../domain/eventos/services'
  import * as Status from '../../../../domain/eventos/helpers/Status'
  import BtnStatus from './BtnStatus.vue'
  import BtnStatusConfirmar from './ConfirmStatus'

  export default {
    components: {
      BtnStatus,
      BtnStatusConfirmar
    },
    nome: 'evento',
    directives: {mask},
    data () {
      return {
        data: null,
        saLogs: [],
        isUploadingFoto: []
      }
    },
    computed: {
      getStatus () {
        return Status.Status
      },
      apiUrl () {
        return process.env.API_URL
      },
      enderecoPrincipal () {
        if (this.data.enderecos && this.data.enderecos.length > 0) {
          let endereco = this.data.enderecos.slice().shift()
          return [endereco]
        }
        return null
      },
      outrosEnderecos () {
        if (this.data.enderecos && this.data.enderecos.length > 1) {
          let enderecos = this.data.enderecos.slice()
          enderecos.shift()
          return enderecos
        }
        return null
      }
    },
    mounted () {
    },
    activated () {
    },
    created () {
      this.$loaderOverlay.open().message('Aguarde enquanto carregamos os dados')
      service.find(this.$route.params.id)
        .then((response) => {
          this.$loaderOverlay.hide()
          this.data = response.data
        })
        .catch((response) => {
          this.$loaderOverlay.hide()
          console.log(response)
        })
    },
    deactivated () {
      this.$destroy() // no keep-alive
    },
    watch: {},
    methods: {
      confirmarAlteracaoStatus (v) {
        this.$refs.confirmarStatus.open(v, this.data.status, (newStatus) => {
          let oldStatus = this.data.status
          this.data.status = newStatus
          service.atualizaStatus(this.data.id, newStatus)
            .then((response) => {
              // nothing to do
            })
            .catch((response) => {
              window.alert('Não foi possível atualizar o status, algum problema ocorreu, tente novamente.')
              this.data.status = oldStatus
              console.log(response)
            })
        })
      },
      Status () {
        return Status
      },
      round: function (number, precision) {
        let factor = Math.pow(10, precision)
        let tempNumber = number * factor
        let roundedTempNumber = Math.round(tempNumber)
        return roundedTempNumber / factor
      },
      print: function () {
        window.print()
      },
      adjustFirstLetter (v) {
        return v.charAt(0).toLowerCase() + v.slice(1)
      },
      editar () {
        this.$router.push({name: 'evento.editar', params: {id: this.data.id}})
      },
      deletar () {
        if (!window.confirm('Tem certeza que deseja remover este cadastro?')) {
          return
        }
        service.deletar(this.data.id)
          .then((response) => {
            alert('Deletado com sucesso!')
            this.$router.push({name: 'eventos'})
          })
          .catch((error) => {
            alert('Não foi possível deletar')
            console.log(error)
          })
      },
      defineFotoDestaque (id, fotoIndex) {
        // Not work: https://stackoverflow.com/questions/42807888/vuejs-and-vue-set-update-array
        this.data.fotos[fotoIndex].atualizandoDestaque = true
        service.setFotoDestaque(this.data.id, id)
          .then((response) => {
            delete this.data.fotos[fotoIndex].atualizandoDestaque
            for (let foto in this.data.fotos) {
              if (this.data.fotos[foto].id === id) {
                this.data.fotos[foto].destaque = true
              } else {
                this.data.fotos[foto].destaque = false
              }
            }
          })
          .catch((response) => {
            delete this.lote.fotos[fotoIndex].atualizandoDestaque
            window.alert('Não foi possível atualizar a imagem para destaque, algum problema ocorreu, tente novamente.')
            console.log(response)
          })
      },
      uploadFoto (e) {
        if (e.target.files.length > 1) {
          for (let i = 0; i < e.target.files.length; i++) {
            this.uploadFotoIndividual(e.target.files[i])
          }
        } else {
          this.uploadFotoIndividual(e.target.files[0])
        }
      },
      uploadFotoIndividual (foto) {
        this.isUploadingFoto.push(foto)
        let formData = new FormData()
        formData.append('file', foto, foto.name)
        service.uploadFoto(this.data.id, formData)
          .then((response) => {
            // this.$set(this.lote.fotos, response.data)
            this.data.fotos = response.data
            this.isUploadingFoto.splice(this.isUploadingFoto.indexOf(foto), 1)
            console.log(response)
          })
          .catch((response) => {
            this.isUploadingFoto.splice(this.isUploadingFoto.indexOf(foto), 1)
            window.alert('Não foi possível fazer o upload da foto, algum problema ocorreu, tente novamente.')
            console.log(response)
          })
      },
      removeFoto (id) {
        // TODO: Confirm
        let nodeFoto = this.$el.querySelector('#ltFoto' + id)
        nodeFoto.classList.add('hide')
        let parent = nodeFoto.parentNode
        service.deleteFoto(this.data.id, id)
          .then((response) => {
            parent.removeChild(nodeFoto)
            console.log(response)
          })
          .catch((response) => {
            window.alert('Não foi possível deletar a foto, algum problema ocorreu, tente novamente.')
            nodeFoto.classList.remove('hide')
            console.log(response)
          })
      }
    }
  }
</script>

<template>
  <transition name="slide">
    <div v-if="data !== null" class="content-transition">
      <btn-status-confirmar :Status="getStatus" ref="confirmarStatus"></btn-status-confirmar>
      <div class="fade-in-down">
        <div class="bg-light lter b-b wrapper-md">
          <div class="row">
            <div class="col-md-4">
              <h4 class="m-n font-thin h4">Evento Cod.: #{{ data.codigo }}</h4>
              <h1 class="m-n font-thin h3">{{ data.titulo }}</h1>
              <span class="label no-radius bg-dark"></span>
              <span class="label m-l-n-xxs no-radius bg-success"></span>
              <!--<span class="label m-l-n-xxs no-radius bg-white ">{{ data.comitente.pessoa.nome }}</span>-->
            </div>
            <div class="col-md-8">
              <div class="visible-xs m-t-lg"></div>
              <u-button class="btn btn-sm btn-info pull-right pull-none-xs hidden-print" tabindex="1"
                        @click.prevent="print"><i class="fa fa-print m-r-xs"></i> Imprimir
              </u-button>
              <u-button class="btn btn-sm btn-default pull-right pull-none-xs m-r-sm hidden-print" tabindex="1"
                        @click.prevent="editar">
                <i class="fa fa-edit m-r-xs"></i> Editar
              </u-button>
              <btn-status :Status="getStatus" :value="data.status" @input="confirmarAlteracaoStatus"
                          class="pull-right pull-none-xs m-r-sm hidden-print"></btn-status>
              <u-button class="btn btn-sm btn-default btn-danger pull-right pull-none-xs m-r-sm hidden-print"
                        tabindex="1"
                        @click.prevent="deletar">
                <i class="fa fa-edit m-r-xs"></i> Deletar
              </u-button>
              <router-link :to="{name: 'eventos'}"
                           class="pull-right pull-none-xs hidden-print m-t-xs m-r"
                           style="clear: left"><strong class="label no-radius bg-info">Voltar</strong>
              </router-link>
            </div>
          </div>
        </div>
        <div class="wrapper-md">

          <div class="row">
            <div class="col-xs-12 col-md-6">
              <p>
                ID: <strong>{{ data.id }}</strong> <br>
                Data do cadastro: <strong>{{ moment(data.dateAdded.date).fromNow() }}</strong> <br>
                Título: <strong>{{ data.titulo }}</strong><br>
              </p>

              <p v-if="data.observacao">
                <strong>Observações</strong><br><br>
                {{ data.observacao }}
              </p>

            </div>
            <div class="col-xs-12 col-md-6 text-right">

            </div>

            <div class="col-xs-12" v-if="data.descricao">
              <strong>Descrição do evento</strong><br><br>
              {{ data.descricao }}
            </div>

            <div class="col-xs-12">
              <div class="m-b m-t-lg">Fotos</div>
              <div class="fotos-flex">
                <div v-for="(foto, index) in data.fotos" :id="'ltFoto' + foto.id" class="foto">
                  <a :href="foto.url" target="_blank"> <img :src="foto.urlMin" class="img-responsive"></a>
                  <span v-if="foto.destaque" class="destaque">Destaque</span>
                  <div class="btn-actions">
                    <!--<u-button class="btn btn-xs btn-block btn-default"><i class="fa fa-photo"></i> Maximizar</u-button>-->
                    <u-button @click="defineFotoDestaque(foto.id, index)" class="btn btn-xs btn-block btn-success">
                      <span v-if="!foto.atualizandoDestaque">Tornar Destaque</span>
                      <span v-if="foto.atualizandoDestaque">Trabalhando nisso...</span>
                    </u-button>
                    <u-button @click="removeFoto(foto.id)" class="btn btn-xs btn-block btn-danger">Remover</u-button>
                  </div>
                </div>
                <div class="foto">
                  <u-button v-if="isUploadingFoto.length < 1" class="btn btn-info fileContainer hidden-print"><i
                    class="fa fa-upload m-r-sm"></i> Adicionar nova foto <input
                    @change="uploadFoto" multiple accept="image/*" type="file"/></u-button>
                </div>
                <div v-for="foto1 in isUploadingFoto" class="foto">
                  <div class="text-center"
                        style="display: inline-flex; width: 200px; height: 200px; align-content: center; align-items: center">
                    <div style="display: block">
                      <i class="fa fa-spin fa-spinner"></i>
                    <div>Enviando foto</div>
                  </div>
                  </div>
                </div>
              </div>
            </div>
          </div>


        </div>
      </div>
    </div>
  </transition>
</template>



// WEBPACK FOOTER //
// Visualizar.vue?58ec7ed0